/* Copyright (C) Nicolas Lochet - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Nicolas Lochet <nicolas@lochet.com>, 2024
 */

import { Component } from 'llama'
import FaceDrawer from '../../common/FaceDrawer'
import FacePartSelector from './FacePartSelector'

export default class FacePartNoseMouth extends Component {
  constructor (opt) {
    super({
      ...opt,
      html: () => `<div id="part-choice-nose" class="part-choice four-cols"></div>
      <div id="part-choice-mouth" class="part-choice four-cols"></div>`
    })
  }

  init (params, path) {
    const { eventBus, context } = this

    const faceDrawer = new FaceDrawer()
    this.addChildren(
      params, path,

      new FacePartSelector({
        name: 'FacePartSelector:nose',
        eventBus,
        context,
        box: 'part-choice-nose',
        num: 4,
        draw (ctx, i) {
          faceDrawer.drawNose(ctx, i, 2, 5, -35)
        },
        shape: 'nose',
        width: 60,
        height: 40
      }),

      new FacePartSelector({
        name: 'FacePartSelector:mouth',
        eventBus,
        context,
        box: 'part-choice-mouth',
        num: 4,
        draw (ctx, i) {
          faceDrawer.drawMouth(ctx, i, 2, 5, -35)
        },
        shape: 'mouth',
        width: 60,
        height: 30
      })
    )
  }
}
